// ключ для хранения userId в localStorage
export const LOCAL_STORAGE_KEY_USER_ID = 'lt-frontend-user-id' as const;

// ошибка, которая выкенется если вызвать функцию в SSR окружении
export const ERROR_MESSAGE_SSR =
  'getUserId пытаются вызвать в SSR окружении' as const;
